import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { getSafeAreaPaddings, getTheme } from "@src/appV2/redesign/system/ui-theme";

import { PageWrapper } from "../../redesign/components/PageWrapper";
import { Navbar } from "../../redesign/Navbar";
import { ChatListPage } from "./Page";

export function ChatListContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <PageWrapper
        variant="tertiary"
        sx={{
          ...getSafeAreaPaddings({
            top: true,
          }),
        }}
      >
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <ChatListPage />
        </Box>
        <Navbar />
      </PageWrapper>
    </ThemeProvider>
  );
}
